import ModulesUtils from 'infra/ModulesUtils'

const Config = {
  getModuleKey: (moduleKey) => {
    if (moduleKey.indexOf('task') !== -1) {
      return 'tasks';
    }
    if (moduleKey.indexOf('notes') !== -1){
      return 'notes';
    }
    return moduleKey
  },
  modules: {
    "index":{
      "key": "index",
      "label": "#",
      "columnWidth": 50,
      "default": true,
      "order": 0,
      location: function (data){
        return null;
      }
    },
    "address":{
      "key": "address",
      "label": "Address",
      "columnWidth": 100,
      "default": false,
      location: function(data) {
        const module = data.commonInfo.modules['address'];
        if (module){
          return module.value;
        }
        return;
      },
      toCSVFormat: function(data){
        return data
      }
    },
    "contactInfo": {
      "key": "contactInfo",
      "label": "Customer Info",
      "columnWidth": 100,
      "default": false,
      location: function(data) {
        return data.commonInfo.modules['contactInfo'];
      },
      toCSVFormat: function(data) {
        let result = '';
        if (data && data.name) {
          result += data.name;
        }
        if (data && data.phoneNumber) {
          result += `, ${data.phoneNumber}`
        }
        if (data && data.email) {
          result += `, ${data.email}`
        }
        return result;
      }
    },
    "contactId": {
      "key": "contactId",
      "label": "Customer ID",
      "columnWidth": 100,
      "default": false,
      location: function(data) {
        return data.commonInfo.modules['contactInfo'];
      },
      toCSVFormat: function(data) {
        return (data && data.id) ? data.id : '';
      }
    },
    "date": {
      "key": "date",
      "label": "Date",
      "columnWidth": 100,
      "default": false,
      location: function(data, dateStr) {
        return dateStr
      },
      toCSVFormat: function(data){
        return data
      }
    },
    "description": {
      "key": "description",
      "label": "Description",
      "columnWidth": 150,
      "default": false,
      location: function(data) {
        const module = data.commonInfo.modules['description'];
        if (module){
          return module.value;
        }
        return;
      },
      toCSVFormat: function(data){
        return data
      }
    },
    "displayName":{
      "key": "displayName",
      "label": "Name",
      "columnWidth": 250,
      "default": true,
      "order": 1,
      location: function(data) {
        const module = data.commonInfo.modules['displayName'];
        if (module){
          return module.value;
        }
        return;
      },
      toCSVFormat: function(data){
        return data
      }
    },
    "materials": {
      "key": "materials",
      "label": "Materials",
      "columnWidth": 250,
      "default": false,
      location: function(data) {
        const module = data.extendedInfo && data.extendedInfo.modules && data.extendedInfo.modules['materials'];
        if (module){
          return module.list;
        }
        return;
      },
      toCSVFormat: function(data){
        const materialsList = []
        data.forEach(material => {
          let cost = '';
          if (material.cost){
            cost = `$${material.cost}`
          }
          materialsList.push(`${material.name}, ${cost}, ${material.quantity} ${material.units}, ${material.store}`)
        })
        return materialsList.join(', ');
      }
    },
    "notes": {
      "key": "notes",
      "label": "Notes",
      "columnWidth": 200,
      "default": true,
      "order": 5,
      location: function(data, dateStr) {
        const modules = data.commonInfo.modules;
        if (modules['notesTeam']) {
          return modules['notesTeam'].list;
        } else if (modules['notesExtended'] && data.extendedInfo && data.extendedInfo.modules) {
          const notesExtendedInfo = data.extendedInfo.modules['notesExtended'];
          return notesExtendedInfo && notesExtendedInfo[dateStr]
            ? notesExtendedInfo[dateStr].list : ''
        }
        return;
      },
      toCSVFormat: function(data){
        return data.join(', ')
      }
    },
    "photos": {
      "key": "photos",
      "label": "Photos",
      "columnWidth": 300,
      "default": true,
      "order": 6,
      location: function(data) {
        const module = data.extendedInfo && data.extendedInfo.modules && data.extendedInfo.modules['photos'];
        if (module){
          return module.list;
        }
        return;
      },
      toCSVFormat: function(data){
        return;
      }
    },
    "tasks": {
      "key": "tasks",
      "label": "Tasks",
      "columnWidth": 250,
      "default": false,
      location: function(data, dateStr) {
        let result = {};
        const modules = data.commonInfo.modules;
        const extendedModules = data.extendedInfo && data.extendedInfo.modules;

        // Normal Tasks
        if (modules['tasks'] && modules['tasks']._type === 'initial') {
          result = Object.assign(result, modules['tasks'].list);
        }
        // Shared Tasks
        if (modules['sharedTasks'] && extendedModules && extendedModules['tasks']) {
          result = Object.assign(result, extendedModules['tasks'].list);
        }

        // Instance Tasks
        if (extendedModules && extendedModules['tasksInstance'] && extendedModules['tasksInstance'][dateStr]) {
          result = Object.assign(result, extendedModules['tasksInstance'][dateStr].list);
        }

        // Recurrent Tasks
        if (modules && extendedModules && extendedModules['tasksRecurrent'] && extendedModules['tasksRecurrent'].done
          && extendedModules['tasksRecurrent'].done[dateStr]) {
          const recurrentTaskList = modules['tasksRecurrent'] && modules['tasksRecurrent'].list;
          const doneTaskList = extendedModules['tasksRecurrent'].done[dateStr].list;

          if (recurrentTaskList){
            Object.keys(doneTaskList).forEach(taskKey => {
              if (recurrentTaskList[taskKey]){
                result[taskKey] = Object.assign({}, recurrentTaskList[taskKey],
                  doneTaskList[taskKey]);
              }
            })
          }
        }

        return result;
      },
      toCSVFormat: function(data){
        const tasksList = []
        data.forEach(task => {
          if (task.done) {
            tasksList.push(`${task.text}`)
          }
        })
        return tasksList.join(', ');
      }
    },
    "workers": {
      "key": "workers",
      "label": "Assignees",
      "columnWidth": 100,
      "default": true,
      "order": 4,
      location: function(data) {
        const module = data.commonInfo.modules['workers'];
        if (module){
          return module.list;
        }
        return;
      },
      toCSVFormat: function(data){
        return data.join(', ')
      }
    },
    "assistants": {
      "key": "assistants",
      "label": "Assistants",
      "columnWidth": 100,
      "default": false,
      location: function(data, dateStr) {
        return data.extendedInfo
                && data.extendedInfo.modules
                && data.extendedInfo.modules['assistants']
                && data.extendedInfo.modules['assistants'][dateStr];
      },
      toCSVFormat: function(data){
        return data.join(', ')
      }
    },
    "laborers": {
      "key": "laborers",
      "label": "Laborers",
      "columnWidth": 100,
      "default": false,
      location: function(data, dateStr) {
        return data.commonInfo.modules['laborers'];
      },
      toCSVFormat: function(data){
        return data.join(', ')
      }
    },
    "target":{
      "key": "target",
      "label": "Target",
      "columnWidth": 100,
      "default": true,
      "order": 2,
      location: function(data) {
        if (data.commonInfo.modules['clockingTeam']) {
          return data.commonInfo.modules['clockingTeam']
        }
        if (data.commonInfo.modules['clockingWorker']) {
          return data.commonInfo.modules['clockingWorker']
        }
        return data.commonInfo.modules['clockingExtended']
      },
      toCSVFormat: function(data){
        return `${data.target} min`;
      }
    },
    "actual":{
      "key": "actual",
      "label": "Actual",
      "columnWidth": 100,
      "default": true,
      "order": 3,
      location: function(data, dateStr) {
        if (data.commonInfo.modules['clockingTeam']) {
          return data.commonInfo.modules['clockingTeam'];
        }
        if (data.commonInfo.modules['clockingWorker']) {
          return data.extendedInfo
            && data.extendedInfo.modules
            && data.extendedInfo.modules['clockingWorker']
            && data.extendedInfo.modules['clockingWorker'][dateStr]
        }
        return data.extendedInfo
          && data.extendedInfo.modules
          && data.extendedInfo.modules['clockingExtended']
          && data.extendedInfo.modules['clockingExtended'][dateStr]
      },
      toCSVFormat: function(data) {
        return data.diff ? `${data.diff} min` : null
      }
    },
    "clockInOut":{
      "key": "clockInOut",
      "label": "Time In - Out",
      "columnWidth": 150,
      location: function(data, dateStr) {
        if (data.commonInfo.modules['clockingTeam']) {
          return data.commonInfo.modules['clockingTeam']
        }
        if (data.commonInfo.modules['clockingWorker']) {
          return data.extendedInfo
            && data.extendedInfo.modules
            && data.extendedInfo.modules['clockingWorker']
            && data.extendedInfo.modules['clockingWorker'][dateStr]  
        }
        return data.extendedInfo
          && data.extendedInfo.modules
          && data.extendedInfo.modules['clockingExtended']
          && data.extendedInfo.modules['clockingExtended'][dateStr]
      },
      toCSVFormat: function(data) {
        let entry = '';
        if (data) {
          if (data.type === 'clockingExtended') {
            if (data.start){
              entry += data.start;
            }
            entry += ' - ';
            if (data.end){
              entry += data.end;
            }
          }
          if (data.type === 'clockingWorker') {
            const entries = []
            for (const workerId in data.list) {
              const name = ModulesUtils.getMemberName(workerId)
              entries.push(`${name}: ${data.list[workerId].timeIn || ''} - ${data.list[workerId].timeOut || ''}`)
            }
            entry = entries.join(', ')
          }
        }
        return entry;
      }
    },
    jobType: {
      key: 'jobType',
      label: 'Job Type & Frequency',
      columnWidth: 150,
      default: true,
      location: data => {
        if (data.commonInfo.modules['lineItems']) {
          return { typeInfo: 'Install' }
        }
        if (data.commonInfo.modules['tasksRecurrent']) {
          const dateInfo = data.commonInfo.modules.date
          let summary = ''
          if (dateInfo) {
            summary = ' - ' + ModulesUtils.getRecurrenceSummary(dateInfo)
          }
          return { typeInfo: 'Recurrent' + summary }
        }
        return { typeInfo: 'Service' }
      },
      toCSVFormat: data => {
        return data.typeInfo
      }
    }
  }
}

export default Config



// WEBPACK FOOTER //
// ./src/reports/service/ServiceColumnConfig.js